import { useQuery } from '@apollo/client';

import CitySearch from 'bundles/employability-common/queries/CitySearch.graphql';
import type {
  CitySearchQuery,
  CitySearchQueryVariables,
} from 'bundles/employability-common/queries/__generated__/CitySearch';

export const useCitySearchQuery = (variables: CitySearchQueryVariables) => {
  const { data, loading, error } = useQuery<CitySearchQuery, CitySearchQueryVariables>(CitySearch, {
    variables,
    context: { clientName: 'gatewayGql' },
  });

  return {
    loadingCities: loading,
    citiesError: error,
    cities: data?.CitySearch?.searchCities.elements || [],
  };
};
